export class Mutations {
    public static readonly SetAllEnquiries: string = 'setAllEnquiries';
    public static readonly SetAllEnquiriesPage: string = 'setAllEnquiriesPage';
    public static readonly SetAllEnquiriesPageSize: string = 'setAllEnquiriesPageSize';
    public static readonly SetAllEnquiriesTotalPages: string = 'setAllEnquiriesTotalPages';
    public static readonly SetAllEnquiriesTotalEnquiries: string = 'setAllEnquiriesTotal';
    public static readonly SetAllEnquiriesKeyword: string = 'setAllEnquiriesKeyword';
    public static readonly SetAllEnquiriesFilterStatus: string = 'setAllEnquiriesFilterStatus';
    public static readonly SetAllEnquiriesFrom: string = 'setAllEnquiriesFrom';
    public static readonly SetAllEnquiriesTo: string = 'setAllEnquiriesTo';

    public static readonly SetMyEnquiries: string = 'setMyEnquiries';
    public static readonly SetMyEnquiriesPage: string = 'setMyEnquiriesPage';
    public static readonly SetMyEnquiriesPageSize: string = 'setMyEnquiriesPageSize';
    public static readonly SetMyEnquiriesTotalPages: string = 'setMyEnquiriesTotalPages';
    public static readonly SetMyEnquiriesTotalEnquiries: string = 'setMyEnquiriesTotal';
    public static readonly SetMyEnquiriesKeyword: string = 'setMyEnquiriesKeyword';
    public static readonly SetMyEnquiriesFilterStatus: string = 'setMyEnquiriesFilterStatus';
    public static readonly SetMyEnquiriesFrom: string = 'setMyEnquiriesFrom';
    public static readonly SetMyEnquiriesTo: string = 'setMyEnquiriesTo';
}
